import { useCallback } from 'react';
import { useMutation } from '@apollo/client';

import { submitVendorAvailability } from '@/api';
import { resolveGqlErrors } from '@/helpers';

import type { SubmitAvailabilityInput, SubmitAvailabilityResult } from '../types';

type UseSubmitAvailability = {
  submit: (input: SubmitAvailabilityInput) => Promise<SubmitAvailabilityResult>;
  loading: boolean;
  error: string;
};

export const useSubmitAvailability = (): UseSubmitAvailability => {
  const [submitMutation, { loading, error }] = useMutation(submitVendorAvailability);

  const submit = useCallback(
    async (input: SubmitAvailabilityInput): Promise<SubmitAvailabilityResult> => {
      try {
        const { data } = await submitMutation({ variables: { input } });
        const payload = data?.submitVendorAvailability;

        if (!payload) {
          return {
            success: false,
            errors: ['Empty response from server'],
          };
        }

        return {
          success: payload.success,
          errors: payload.error ? [payload.error.message] : [],
        };
      } catch (e) {
        return {
          success: false,
          errors: [resolveGqlErrors(e)],
        };
      }
    },
    [submitMutation]
  );

  return {
    submit,
    loading,
    error: resolveGqlErrors(error),
  };
};
